import type { ElementType } from "react";
import {
  HiOutlineBriefcase,
  HiOutlineBuildingOffice2,
  HiOutlineComputerDesktop,
  HiOutlineDocumentText,
  HiOutlineUserGroup,
  HiOutlineVideoCamera,
} from "react-icons/hi2";

import { InterviewQuestionsIcon } from "./icons";

export const CATEGORY_ICONS: Record<string, ElementType> = {
  JOB_DESCRIPTION: HiOutlineBriefcase,
  CURRENT_INTERVIEW_PROCESS: InterviewQuestionsIcon,
  IDEAL_CANDIDATE_PROFILE: HiOutlineUserGroup,
  CULTURE_AND_TEAM_CONTEXT: HiOutlineBuildingOffice2,
  PAST_INTERVIEW_MATERIAL: HiOutlineVideoCamera,
  NONE_OF_THE_ABOVE: HiOutlineDocumentText,
  URL_SOURCE: HiOutlineComputerDesktop,
};

export const DEFAULT_CATEGORY_ICON = HiOutlineDocumentText;
